module.exports = __webpack_public_path__ + "img/list-icon.958aa06.svg";